<div class="dialog-container">
  <div class="gb-dialog-header">
    <h1>
      {{ 'PRESENTER.RENAME_SLIDE_DIALOG.TITLE' | translate }}
    </h1>
    <button mat-icon-button (click)="cancel()">
      <gb-icon [icon]="'close'"></gb-icon>
    </button>
  </div>

  <div class="gb-dialog-content">
    <gb-form-field labelTranslateKey="PRESENTER.RENAME_SLIDE_DIALOG.LABEL" [control]="nameControl"></gb-form-field>
  </div>

  <div class="gb-flex-button-container gb-dialog-actions-container">
    <button mat-stroked-button (click)="cancel()">
      <span>{{ 'CANCEL' | translate }}</span>
    </button>

    <button mat-flat-button (click)="save()" [disabled]="nameControl.invalid">
      <span>{{ 'SAVE' | translate }}</span>
    </button>
  </div>
</div>
